import type { FC } from 'react';

import { Typography } from '@/modules/perseo-billing/ui/react/src/components/beta';

type TSummaryQuantity = {
  quantity: number;
};

const SummaryQuantity: FC<TSummaryQuantity> = ({ quantity }) => {
  const singularLabel = 'entrega';
  const pluralLabel = 'entregas';
  const label = quantity > 1 ? pluralLabel : singularLabel;

  return (
    <Typography
      align="center"
      weight="semibold"
      className="co-min-w-[65px]"
      color="pds-neutral-700"
      leading="tight"
    >
      {quantity} {label}
    </Typography>
  );
};

export default SummaryQuantity;
